import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from './../icon';
import { Tag } from './../tag';
import './articleTitle.css';

const ArticleTitle = props => {
  const {isSearchArticle} = props;
  return (
    <div className="article-title article-title-wrapper">
      <div className="at-buttons">
        {props.allowShare && (
          <div
            className="at-button"
            onClick={ev => {
              ev.preventDefault();
              props.onClickShare();
            }}
          >
            <Icon name="share" />
          </div>
        )}
      </div>
      <div className="title">
        <div className="at-upper-content">
          {props.tags.map(tag => {
            return <Tag key={tag} title={tag} />;
          })}
        </div>
        {props.subtitle || props.extra ? (
          <div style={{ marginTop: 0, paddingBottom: 1 }}>
            {isSearchArticle ? 
            <React.Fragment>
              <div className="title-content">{props.title}</div>
              {props.subtitle ? (
                <span className="subtitle">{props.subtitle}</span>
              ) : null}
              {props.extra ? (
                <span className="extra text-primary">
                  <span style={{ color: '#FFFFFF' }}> | </span>
                  {props.extra}
                </span>
              ) : null}
            </React.Fragment> :
            <React.Fragment>
              <div className="title-content title-content-article">{props.title}</div>
             {props.subtitle ? (
              <span className="btn text-uppercase pill pill-article"><strong>
                {props.subtitle}</strong></span>
              ) : null}
              {props.extra ? (
                <span className="btn text-uppercase pill pill-article">
                  {/* <span style={{ color: '#FFFFFF' }}> | </span> */}
                  <strong>
                    {props.extra}
                  </strong>
                </span>
              ) : null}
            </React.Fragment>
          }
          </div>
        ) : null}
        
      </div>
    </div>
  );
};

ArticleTitle.defaultProps = {
  tags: [],
  onClickShare: () => {},
  allowShare: true,
  isSearchArticle: false,
};

ArticleTitle.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  extra: PropTypes.string,
  tags: PropTypes.array,
  onClickShare: PropTypes.func,
  allowShare: PropTypes.bool,
  isSearchArticle: PropTypes.bool,
};

export default ArticleTitle;



// WEBPACK FOOTER //
// ./src/ui/src/component/article/articleTitle.js